import axios from 'axios';
import { Config } from '../config';
import { PlaceDto, PlaceSearchDto } from '@/model/place.dto';

export class PlaceApi {
  public async getPlaceCheck(accessToken: string, name: string): Promise<any> {
    const url = `${Config.API_URL}/console/access/place/check/${name}`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    return await axios.get(url, { headers });
  }
  public async getPlaceList(
    accessToken: string,
    dto?: PlaceSearchDto,
  ): Promise<PlaceDto[]> {
    const url = `${Config.API_URL}/console/access/place`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    const params = dto;
    const res = await axios.get(url, { headers, params });
    return res.data;
  }
  public async getFilterPlaceList(
    accessToken: string,
    dto: PlaceSearchDto,
  ): Promise<PlaceDto[]> {
    const url = `${Config.API_URL}/console/access/place`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    const params = dto;
    const res = await axios.get(url, { headers, params });
    return res.data;
  }

  public async postPlaceAdd(accessToken: string, dto: PlaceDto): Promise<any> {
    const url = `${Config.API_URL}/console/access/place`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    await axios.post<PlaceDto>(url, dto, { headers });
  }

  public async putPlaceModify(
    accessToken: string,
    id: number,
    dto: PlaceDto,
  ): Promise<any> {
    const url = `${Config.API_URL}/console/access/place/${id}`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    await axios.put<PlaceDto>(url, dto, { headers });
  }

  public async delPlaceList(accessToken: string, ids: number[]): Promise<any> {
    const url = `${Config.API_URL}/console/access/place`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    ids.map(async (id) => {
      const params = {
        ids: id,
      };
      await axios.delete(url, { headers, params });
    });
  }
}
